import React from "react";

import {
  Container,
  ContentWrapper,
  FixedHeader,
  HeaderContent,
} from "./styles";

type Props = {
  leftContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  isOverlay?: boolean;
  disabled?: boolean;
};

const Header: React.FC<Props> = ({
  isOverlay,
  leftContent,
  centerContent,
  rightContent,
  disabled,
}) => {
  return (
    <Container isOverlay={isOverlay} disabled={disabled}>
      <FixedHeader>
        <HeaderContent>
          <ContentWrapper>{leftContent}</ContentWrapper>
          <ContentWrapper>{centerContent}</ContentWrapper>
          <ContentWrapper>{rightContent}</ContentWrapper>
        </HeaderContent>
      </FixedHeader>
    </Container>
  );
};

export default Header;
